import React from 'react';

const NotificationSkeletonLoader = () => (
    <li className="group bg-white px-3 hover:bg-gray50 flex flex-col">
        <div className="flex relative items-start pt-3 pb-3 border-b border-utilityGray200">
            <div className="flex items-center pt-1 min-w-[8px] mr-3">
                <p className="bg-primary w-2 h-2 rounded-[3px] custom-loading"></p>
            </div>

            <div className="flex flex-col gap-2">
                <div className="flex gap-x-2 flex-row items-center">
                    <span className="text-grayLight900 font-medium truncate max-w-[90px] text-[12px] leading-[16px] custom-loading">Quote</span>
                    <span className="w-1.5 h-1.5 bg-gray400 rounded-full flex items-center justify-center"></span>
                    <span className="text-grayLight600 text-[12px] leading-[16px] font-normal custom-loading">Dec 15 at 12:30 PM</span>
                </div>
                <div className="flex flex-col gap-1 w-full">
                    <span className="flex flex-row items-center gap-x-1">
                        <span className="text-textSecondary font-semibold truncate text-[12px] leading-[20px] custom-loading">Quote Created Successfully</span>{' '}
                        <span className="text-primary700 font-semibold text-[12px] leading-[20px] custom-loading">#WAL-EIID-33-A</span>
                    </span>
                    <div className="flex gap-x-1 flex-row items-center">
                        <span className="text-textSecondary font-medium truncate text-[12px] leading-[18px] custom-loading">#WAL-EIID-33-A Quote Request Created Successfully.</span>
                    </div>
                    <div className="text-grayLight600 text-[12px] leading-[18px] font-normal">
                        <span className="text-textSecondary font-normal text-[12px] leading-[20px] custom-loading"> Approved by </span>
                        <span className="text-primary700 font-medium text-[12px] leading-[20px] custom-loading">Alisa Hester</span>{' '}
                    </div>
                </div>
            </div>
        </div>
    </li>
);

export default NotificationSkeletonLoader;
